// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconAlphaK = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M8.487 6.948h1.75v4.074h.644l3.5-4.074h2.128l-4.256 4.746 4.018 4.816V17h-1.736l-3.654-4.452h-.644V17h-1.75z" />,
    <path
      fillRule="evenodd"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1116 0 8 8 0 01-16 0"
    />
  );
export default SvgIconAlphaK;
